import { useEffect, useState } from 'react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';
import { formatFileSize } from './govtJobPhotoSignEngine';

function PreviewCard({ title, url, meta }) {
    return (
        <div className="flex min-h-0 flex-1 flex-col gap-1.5">
            <p className="text-center text-[11.5px] font-semibold text-[#6B635C] dark:text-zinc-400">{title}</p>
            <div className="flex min-h-[120px] flex-1 items-center justify-center overflow-hidden rounded-xl border border-[#ECE8E4] bg-white p-2 dark:border-zinc-700 dark:bg-zinc-900">
                {url ? (
                    <img src={url} alt={title} className="max-h-full max-w-full object-contain" draggable={false} />
                ) : null}
            </div>
            {meta ? (
                <p className="text-center text-[11px] text-[#A8A099] dark:text-zinc-500">{meta}</p>
            ) : null}
        </div>
    );
}

export default function GovtJobPhotoSignPreview({ photoBlob, signatureBlob }) {
    const { t } = useTranslation();
    const [photoUrl, setPhotoUrl] = useState(null);
    const [signatureUrl, setSignatureUrl] = useState(null);

    useEffect(() => {
        if (!photoBlob) {
            setPhotoUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(photoBlob);
        setPhotoUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [photoBlob]);

    useEffect(() => {
        if (!signatureBlob) {
            setSignatureUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(signatureBlob);
        setSignatureUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [signatureBlob]);

    if (!photoBlob && !signatureBlob) return null;

    return (
        <div className="flex h-full min-h-0 flex-col gap-3">
            <PreviewCard
                title={t('govtJobPhotoSign.previewPhoto')}
                url={photoUrl}
                meta={photoBlob ? `${t('govtJobPhotoSign.photoSize')} · ${formatFileSize(photoBlob.size)}` : null}
            />
            <PreviewCard
                title={t('govtJobPhotoSign.previewSignature')}
                url={signatureUrl}
                meta={signatureBlob ? `${t('govtJobPhotoSign.signatureSize')} · ${formatFileSize(signatureBlob.size)}` : null}
            />
        </div>
    );
}
